import moment from 'moment'
import { DATE_DISPLAY_FORMAT, DATE_DISPLAY_FORMAT_HOURS } from '../constants/dateFormats'

export const formatDate = (date) => {
  return moment(date || new Date()).format(DATE_DISPLAY_FORMAT)
}

export const formatDateAndTime = (date) => {
  return moment(date || new Date()).format(DATE_DISPLAY_FORMAT_HOURS)
}
